import { createContext, useContext, useState, ReactNode } from 'react';
import { AboutWitboostModal } from './AboutWitboostModal';

interface AboutWitboostModalContextType {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
}

const AboutWitboostModalContext = createContext<
  AboutWitboostModalContextType | undefined
>(undefined);

export const AboutWitboostModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const value = {
    openModal,
    closeModal,
    isOpen,
  };

  return (
    <AboutWitboostModalContext.Provider value={value}>
      {children}
      <AboutWitboostModal open={isOpen} onClose={closeModal} />
    </AboutWitboostModalContext.Provider>
  );
};

export const useAboutWitboostModal = () => {
  const context = useContext(AboutWitboostModalContext);
  if (context === undefined) {
    throw new Error(
      'useAboutWitboostModal must be used within an AboutWitboostModalProvider',
    );
  }
  return context;
};
